export default __webpack_public_path__ + "static/media/blog.be4d1a43.jpg";